import { BedDouble, Briefcase, Building2, Plane } from "lucide-react";
import { SECTION_LABEL } from "@/lib/site";
import { Reveal, Stagger, StaggerItem } from "@/components/Reveal";

const SOLUTIONS = [
    {
        icon: Building2,
        title: "Digital Agencies",
        desc: "Additional delivery capacity for client websites, portals, web applications and automation — under your brand.",
        id: "agencies",
    },
    {
        icon: BedDouble,
        title: "Hotels & Hostels",
        desc: "Digital booking experiences, enquiry management and practical hospitality workflows that lighten front-desk load.",
        id: "hospitality",
    },
    {
        icon: Plane,
        title: "Travel & Tourism",
        desc: "Travel websites, itinerary and quotation tools, booking enquiry flows and customer communication.",
        id: "travel",
    },
    {
        icon: Briefcase,
        title: "Service Businesses",
        desc: "Lead management, repetitive-task automation and custom internal tools for day-to-day operations.",
        id: "services",
    },
];

export default function Solutions() {
    return (
        <section
            id="solutions"
            className="scroll-mt-20 bg-white"
            data-testid="solutions-section"
        >
            <div className="mx-auto max-w-7xl px-6 py-24 lg:px-8 lg:py-32">
                <Reveal>
                    <p className={SECTION_LABEL}>Solutions</p>
                    <h2 className="mt-4 max-w-3xl font-heading text-3xl font-medium tracking-tight text-[#1C1917] md:text-4xl lg:text-[3.25rem] lg:leading-[1.1]">
                        Built for the way your{" "}
                        <span className="font-serif italic text-[#CF4242]">industry works.</span>
                    </h2>
                    <p className="mt-5 max-w-2xl text-base leading-relaxed text-[#57504A] md:text-lg">
                        We focus on concrete operational problems — the enquiries, bookings,
                        follow-ups and internal tasks that decide how smoothly a business runs.
                    </p>
                </Reveal>

                <Stagger className="mt-16 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
                    {SOLUTIONS.map((s) => (
                        <StaggerItem key={s.id} className="h-full">
                            <article
                                data-testid={`solution-card-${s.id}`}
                                className="spotlight group relative h-full overflow-hidden rounded-[1.25rem] border border-[#EDE3DA] bg-white p-8 shadow-[0_8px_30px_rgb(0,0,0,0.04)] transition-[transform,box-shadow] duration-500 ease-out hover:-translate-y-2 hover:shadow-[0_32px_60px_-24px_rgb(28,25,23,0.35)]"
                            >
                                <span
                                    className="absolute inset-x-0 top-0 h-[3px] origin-left scale-x-0 bg-gradient-to-r from-[#CF4242] via-[#E8764A] to-[#CF4242] transition-transform duration-500 group-hover:scale-x-100"
                                    aria-hidden="true"
                                />
                                <span className="relative flex h-11 w-11 items-center justify-center rounded-xl bg-[#FBECE9] ring-1 ring-[#CF4242]/10 transition-[background-color,transform] duration-500 group-hover:-rotate-6 group-hover:bg-[#CF4242]">
                                    <s.icon
                                        size={20}
                                        className="text-[#CF4242] transition-colors duration-500 group-hover:text-white"
                                        aria-hidden="true"
                                    />
                                </span>
                                <h3 className="relative mt-5 font-heading text-lg font-semibold text-[#1C1917]">
                                    {s.title}
                                </h3>
                                <p className="relative mt-2 text-sm leading-relaxed text-[#57504A]">
                                    {s.desc}
                                </p>
                            </article>
                        </StaggerItem>
                    ))}
                </Stagger>
            </div>
        </section>
    );
}
